/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { CHIP_THEME_DEFAULT, CHIP_TYPE_REMOVABLE, ChipProps, SelectFieldOption } from '@squiz/sds';

export const defaultChips: Array<ChipProps<string>> = [
  {
    key: 'asset:read',
    text: 'asset:read',
    theme: CHIP_THEME_DEFAULT,
    type: CHIP_TYPE_REMOVABLE,
  },
  {
    key: 'asset:write',
    text: 'asset:write',
    theme: CHIP_THEME_DEFAULT,
    type: CHIP_TYPE_REMOVABLE,
  },
  {
    key: 'offline',
    text: 'offline',
    theme: CHIP_THEME_DEFAULT,
    type: CHIP_TYPE_REMOVABLE,
  },
];

export const damIntegrationsSelectOptions: Array<SelectFieldOption> = [
  { key: 'bynder', label: 'Bynder', value: 'bynder' },
];
